module.exports = __webpack_public_path__ + "assets/img/shop_detail_img4.d6556d54.png";